<template>
  <div class="container mt-5 mb-5">
    <div class="row">
      <div class="col-md-8 col-sm-6">
        <div class="card">
          <div class="card-header bg-primary text-white text-uppercase">
            <i class="fa fa-envelope"></i> Contact us
          </div>
          <div class="card-body">
            <form>
              <div class="form-group">
                <label for="name">Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  aria-describedby="emailHelp"
                  placeholder="Enter name"
                  required
                />
              </div>
              <div class="form-group">
                <label for="email">Email address</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  aria-describedby="emailHelp"
                  placeholder="Enter email"
                  required
                />
                <small id="emailHelp" class="form-text text-muted"
                  >We'll never share your email with anyone else.</small
                >
              </div>
              <div class="form-group">
                <label for="message">Message</label>
                <textarea
                  class="form-control"
                  id="message"
                  rows="6"
                  required
                ></textarea>
              </div>
              <div class="mx-auto">
                <button type="submit" class="btn btn-primary text-right">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="card bg-light mb-3">
          <div class="card-header bg-success text-white text-uppercase">
            <i class="fa fa-home"></i> Address
          </div>
          <div class="card-body">
            <p>Ecom Vue Ltd.</p>
            <p>Mohakhali, Dhaka, Bangladesh</p>
            <p>Email : test@test.com</p>
            <p>Tel. +880 111 222 333</p>
          </div>
          <div class="col-lg-6 right-image p-r-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.055689005249!2d90.39691251498193!3d23.781031184574182!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c76c1b798baf%3A0x8fd68e7b4b677e83!2sBrain%20Station%2023!5e0!3m2!1sen!2sbd!4v1625039361406!5m2!1sen!2sbd"
              width="350"
              height="170"
              style="border:0;"
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
};
</script>
